var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHasDisability({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.98278 9.22972C7.31465 9.18663 6.64757 9.32979 6.05081 9.64436C5.45406 9.95892 4.94937 10.4334 4.58917 11.0186C4.22896 11.6037 4.02636 12.2782 4.0024 12.9719C3.97845 13.6657 4.13401 14.3535 4.45294 14.9639C4.77186 15.5742 5.24253 16.0849 5.81606 16.443C6.3896 16.801 7.04509 16.9933 7.71448 16.9998C8.38388 17.0064 9.04276 16.827 9.62273 16.4803C10.2027 16.1337 10.6826 15.6323 11.0126 15.0283M5.125 5.72222L8.125 4.94444L11.125 7.27778L8.875 11.1667H11.875L14.875 15.0556M16 4.94444C16 6.01833 15.1605 6.88889 14.125 6.88889C13.0895 6.88889 12.25 6.01833 12.25 4.94444C12.25 3.87056 13.0895 3 14.125 3C15.1605 3 16 3.87056 16 4.94444Z",
    stroke: "#23242A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHasDisability);
export default __webpack_public_path__ + "static/media/has-disability.30d78f4404493f77947dc4e1f9f8d4de.svg";
export { ForwardRef as ReactComponent };